import React, { useState } from "react";
import { Table, Tag, Typography } from "antd";
import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import moment from "moment";
import Surface from "../../components/layouts/Surface";
import { listEmployeeChangeLogs } from "../../api/server";
import { useSelector } from "react-redux";

const { Text } = Typography;

const EmployeeLogs = ({ activeTab }) => {
  const intl = useIntl();
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
    order: {
      field: "created_at",
      order: "descend",
    },
  });

  const SPECIAL_TERMS = [];
  const { isLoading, data } = useQuery(
    [{ activeEmployee: activeEmployee?.id, tableParams }],
    async () => {
      const result = await listEmployeeChangeLogs({
        employeeId: activeEmployee?.id,
        ...tableParams.pagination,
        order: tableParams.order,
      });
      return {
        items: result.data.items,
        total: result.data.total,
      };
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: Boolean(activeEmployee?.id && activeTab === "logs"),
    }
  );

  const columns = [
    {
      title: intl.formatMessage({ id: "app.logs.table.date" }),
      dataIndex: "created_at",
      width: "150px",
      sorter: true,
      render: (text) => moment(text).format("DD-MM-YYYY"),
    },
    {
      title: intl.formatMessage({ id: "app.logs.table.hour" }),
      dataIndex: "created_at",
      width: "100px",
      render: (text) => moment(text).format("HH:mm"),
    },
    {
      title: intl.formatMessage({ id: "app.logs.table.user" }),
      dataIndex: ["user", "name"],
      width: "200px",
      render: (text, record) => record.user?.name || "-",
    },
    {
      title: intl.formatMessage({ id: "app.logs.table.action" }),
      dataIndex: "action",
      width: "80px",
      render: (text) => (
        <Tag color={text === "update" ? "blue" : "red"}>
          {intl.formatMessage({ id: `app.forms.employee.${text}` })}
        </Tag>
      ),
    },
    {
      title: intl.formatMessage({ id: "app.logs.table.field" }),
      dataIndex: "field",
      width: "200px",
      render: (text) => {
        const suffix = SPECIAL_TERMS.find((term) =>
          text.toLowerCase().includes(term)
        )
          ? ` (${intl.formatMessage({
              id: `app.forms.employee.suffix.${SPECIAL_TERMS.find((term) =>
                text.toLowerCase().includes(term)
              )}`,
            })})`
          : "";
        return (
          <Text>
            {text === ""
              ? text
              : intl.formatMessage({
                  id: `app.forms.employee.${text}`,
                }) + suffix}
          </Text>
        );
      },
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    console.log(sorter);
    setTableParams({
      ...tableParams,
      order: {
        field: sorter.field || "created_at",
        order: sorter.order || "descend",
      },
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });
  };

  return (
    <Surface>
      <Table
        bordered
        columns={columns}
        dataSource={data?.items}
        rowKey={(record) => record.id}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={{
          pageSize: tableParams.pagination.pageSize,
          current: tableParams.pagination.current,
          total: data?.total,
        }}
        scroll={{ y: window.innerHeight - 410 }}
      />
    </Surface>
  );
};

export default EmployeeLogs;
